import imgUpload from './img-upload.vue'
export default imgUpload